import React, { Component, Fragment } from 'react';
import "../../../index.css";
import { withTranslation } from 'react-i18next';
import * as constants from "../constants";
import FilterHelper from "../../../helpers/filterHelper"; 
import { SearchList } from "../Lists/searchList";
import axios from 'axios';
import { SearchOne } from "../SearchOne";
import {
    Container,
    Card,
    CardContent,
    Grid
} from '@material-ui/core';
import * as styles from '../styles';
import Spinner from './../CircularSpinner';
import StatefulSessionHelper from "../../../helpers/statefulSessionHelper";

var isMounted = false;

export class WorkSiteList  extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            rows : [],
            filterOptions : [],
            builderList : [],
            isLoading : false,
            isRowStyle: false,
            CustomerId : "",
            Customer : "",
            cleanData : false,
            title: "",
            expandedSearch: false,
            idSaveLocal: this.props.idSave !== undefined ? this.props.idSave : constants.workSiteFilter
        }
    }

    componentWillUnmount() {
        isMounted = false;
        this.props.cancelPromises();
    }

    componentDidMount() {
        this.setFilter();
        if (this.props.filterId !== undefined) {
            if (this.props.filterId > 0) {
                this.setState({
                    Customer : this.props.filterName,
                    CustomerId : this.props.filterId,
                }, function() {
                    this.loadFilteredRecords();
                });
            }
        }
        else {
            this.loadFilteredRecords();
        }
    }

    loadFilteredRecords = async () => {
        var searchValue = StatefulSessionHelper.getSearchValue(this.state.idSaveLocal + this.props.user.profile.sub);
        if (searchValue === null) {
            searchValue = "";
        }
        
        await this.setState({
            filter : searchValue
        })
    
        var dataValues = StatefulSessionHelper.getValues(this.state.idSaveLocal + this.props.user.profile.sub);
       
        if (dataValues !== null) {
            var expand = false;
          
            if (dataValues.CustomerId !== "") {
                expand = true;
            }

            var tempCustomer = dataValues.Customer;
            var tempCustomerId = dataValues.CustomerId;

            if (this.props.filterId > 0) {
                tempCustomer = this.state.Customer;
                tempCustomerId = this.state.CustomerId;
            }

            this.setState({
                Customer : tempCustomer,
                CustomerId : tempCustomerId,
                expandedSearch: expand
           }, function() {
              this.reloadData();
           })
        }
        else {
            this.reloadData();
        }
    }

    reloadData = () => {
        var data = FilterHelper.getfilterOptions(this.state.idSaveLocal);
        this.loadRecords(this.state.filter, data.sort,1);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.workSites !== this.props.workSites) {
            this.setState({
                rows : this.props.workSites,
            });
        }

    }
    
    setFilter = () => {
        this.setState({
            idSave : this.props.idSave,
        });

        var options = [
            FilterHelper.createFilterOption("number", true, true, 3, constants.textAlign.left, true, "WorksiteNumber", "Number", 1, "Group 1"),
            FilterHelper.createFilterOption("name", true, false, 3, constants.textAlign.left, true, null, "Name", 1, "Group 1"),
            FilterHelper.createFilterOption("key", true, false, 3, constants.textAlign.left, true, "WorksiteKey", "key", 1, "Group 1"),
            FilterHelper.createFilterOption("customer", true, false, 3, constants.textAlign.left, false, null, "None", 1, "Group 1"),
            FilterHelper.createFilterOption("worksiteNumber", true, false, 3, constants.textAlign.left, true, "WorksiteTarget", "WorksiteNumber", 1, "Group 1"),
            FilterHelper.createFilterOption("description", true, false, 4, constants.textAlign.left, true, null, "Description", 2, "Group 2"),
            FilterHelper.createFilterOption("descriptionOnInvoice", true, false, 4, constants.textAlign.left, true, null,  "DescriptionOnInvoice", 2, "Group 2"),
            FilterHelper.createFilterOption("address", true, false, 3, constants.textAlign.left, true, null, "Address.Address", 3, "Group 3"),
            FilterHelper.createFilterOption("addressLine2", true, false, 3, constants.textAlign.left, true, null, "Address.AddressLine2", 3, "Group 3"),
            FilterHelper.createFilterOption("postalCode", true, false, 3, constants.textAlign.left, true, null, "Address.PostalCode", 3, "Group 3"),
            FilterHelper.createFilterOption("city", true, false, 3, constants.textAlign.left, true, null, "Address.City", 3, "Group 3"),
            FilterHelper.createFilterOption("country", true, false, 3, constants.textAlign.left, true, null, "Address.Country", 3, "Group 3"),
        ];

        var filterOptions = FilterHelper.setFilter(this.state.idSaveLocal, options, false);
        
        this.setState({
            filterOptions : filterOptions.filter,
            isRowStyle : filterOptions.isRowStyle
        })
    }

    showFilterFields = (row, rowFilter) => {
        return (
            <Fragment>
                {rowFilter.id === "name" &&
                    this.showRowValue(row.name)
                }
                {rowFilter.id === "number" &&
                    this.showRowValue(row.number)
                }
                {rowFilter.id === "key" &&
                    this.showRowValue(row.key)
                }
                {rowFilter.id === "customer" && 
                    this.showRowValue(row.customer)
                }
                {rowFilter.id === "worksiteNumber" &&
                    this.showRowValue(row.worksiteNumber)
                }
                {rowFilter.id === "description" &&
                    this.showRowValue(row.description)
                }
                {rowFilter.id === "descriptionOnInvoice" &&
                    this.showRowValue(row.descriptionOnInvoice)
                }
                {rowFilter.id === "address" &&
                    this.showRowValue(row.address.address)
                }
                {rowFilter.id === "addressLine2" &&
                    this.showRowValue(row.address.addressLine2)
                }
                {rowFilter.id === "postalCode" &&
                    this.showRowValue(row.address.postalCode)
                }
                {rowFilter.id === "city" &&
                    this.showRowValue(row.address.city)
                }
                {rowFilter.id === "country" &&
                    this.showRowValue(row.address.country)
                }
            </Fragment>
        )
    }

    showRowValue = (value) => {
        return (
            <Fragment>
                {value !== "" ? (
                    value
                ): (
                    <span style={{color:"transparent"}}>
                    .
                    </span>
                )}
            </Fragment>
        )
    } 

    handleClose = () => {
        this.setState({
            cleanData: true
        }, function() {
            this.loadRecords(this.state.filter, "", 1);
        })
    }
    
    loadRecords = async (filter, sort, page) => {
        isMounted = true;

        this.props.cancelPromises();

        var isLoaded = false;
        if (!this.props.isArray) {
            
            if (!this.props.isLoading) {
                this.setState({
                    isLoading : true
                })
            }

            var data = FilterHelper.getfilterOptions(this.state.idSaveLocal);
      
            this.setState({
                filter : filter,
                filterOptions : data.filter,
                isRowStyle: data.isRowStyle
            })

            let cancelToken = axios.CancelToken.source();

            await this.props.cancellablePromise(
               this.props.actions.readWorkSites(
                    filter, data.sort, page, 
                    this.state.CustomerId, 
                    this.state.title,
                    cancelToken.token), cancelToken
            )
            .then(() => {
                isLoaded = true;
            })
            .catch((error) => {
                if (error.message === constants.cancelHttpRequest || error.message === "[object Object]") {
                    isMounted = false;
                }
             })
            .finally(result =>{
                if (isMounted) {
                    this.setState({
                        isLoading : false,
                        cleanData: false
                    })
                }
                
            })
            
        }
        else {
            this.props.loadRecords();
        }

        return isLoaded;
    }
   
    handleDeleteRow = async (record) => {
        if (!this.props.isLoading) {
            this.setState({
                isLoading : true
            })
        }

        record.state = constants.Deleted;
        var data = {...record};

        if (this.props.isTesting) {
            this.setState({
                recordTest : data
            });
        }

        var isDeleted = false;
        await this.props.actions.updateWorkSite(data)
        .then(() => {
            isDeleted = true;
        })
        .catch(() => {})
        .finally(() =>{
            this.setState({
                isLoading : false
            })
        })
        return isDeleted;
    }
    
    handleOneSelect = (row, id) => {
        if (id === "customer") {
            this.setState({
                Customer: row.name,
                CustomerId: row.id,
                cleanData: true
            }, function() {
                this.setSession();
            });
        }
    }

    cleanFilter = (id) => {
        if (id === "customer") {
            this.setState({
                Customer: "",
                CustomerId: "",
                cleanData: true
            }, function() {
                this.setSession();
            });
        }
    }

    setSession = () => {
        var data = {
            Customer : this.state.Customer,
            CustomerId : this.state.CustomerId,
       }
       
       StatefulSessionHelper.setValues(this.state.idSaveLocal + this.props.user.profile.sub, data);
       this.reloadData();
    }

    changeFilter = (filter) => {
        this.setState({
            filter : filter
        })
    }

    showBasket = (show) => {
        if (this.props.showBasket) {
            this.props.showBasket(show);
        }
    }

    handleCatalogs = (id, value ) => {
        this.setState({
            [id]: value,
            cleanData: true
        }, function() {
            this.loadRecords(this.state.filter,"",1);
        });
    }

    render() {
        const { t } = this.props;
        
        return (
            <Fragment>
                {this.state.isLoadingMassive &&
                    <Spinner open={true}/>
                }
                <SearchList 
                    {...this.props}
                    rows={this.state.rows}
                    showtitle={this.props.showtitle}
                    showFilterFields={this.props.showFilterFields ?  this.props.showFilterFields : this.showFilterFields}
                    filterOptions={this.props.filterOptions ? this.props.filterOptions : this.state.filterOptions}
                    isRowStyle={this.props.isRowStyle ? this.props.isRowStyle : this.state.isRowStyle}
                    handleDeleteRow={this.handleDeleteRow}
                    loadRecords={this.loadRecords}
                    //handleJsonFile={this.handleJsonFile}
                    changeFilter={this.changeFilter}
                    cleanData={this.state.cleanData}
                    hideSearch={this.props.hideSearch}
                    //dataRowCaptureIdList={this.props.dataRowCaptureIdList ?  this.props.dataRowCaptureIdList : constants.ContactList}
                    
                    backButton={this.props.backButton !== undefined ? this.props.backButton : false}
                    onlySelect={this.props.onlySelect !== undefined ? this.props.onlySelect :  false}
                    isAllOptions={this.props.isReadOnly}
                    stayInMainWindowIsAllOptions={this.props.stayInMainWindowIsAllOptions}
                    typeModify={constants.workSites}
                    addButton={this.props.addButton !== undefined ? this.props.addButton : true}
                    deleteButton={this.props.deleteButton !== undefined ? this.props.deleteButton  : true}
                    editButton={this.props.editButton !== undefined ? this.props.editButton : true}
                    isToUp={this.props.isToUp !== undefined ? this.props.isToUp : true}
                    title={t(this.props.title !== undefined ? this.props.title : "WorkSites")} 
                    pathBackFromAddEdit={this.props.pathBackFromAddEdit !== undefined ? this.props.pathBackFromAddEdit : "/workSitesList/"}
                    pathAddEdit={this.props.pathAddEdit !== undefined ? this.props.pathAddEdit : "/workSites/"}
                    isLoading={this.state.isLoading}
                    productGroupFilter={this.props.hideFilters ? 
                        undefined
                        :
                        <Grid container style={styles.ElementWithoutPadding}>
                            <Container maxWidth="sm" style={styles.ElementWithoutPadding}>
                                <Card style={styles.CardWithoutBoxes}>
                                    <CardContent style={{...styles.ElementWithoutPadding, ...{padding: "0px"}}}>
                                            <SearchOne
                                                {...this.props}
                                                disabled={this.props.disabled}
                                                id="customerNumber"
                                                label={t("Customer")}
                                                valueOne={this.state.Customer}
                                                handleOneSelect={(row) => this.handleOneSelect(row, "customer")}
                                                cleanFilter={() => this.cleanFilter("customer")}
                                                //changeFilter={this.changeFilter}
                                                typeQuery={constants.customers}
                                                showBasket={this.showBasket}
                                                hideSearch={false}
                                                handleClose={this.handleClose}
                                                isReadOnly={this.props.isReadOnly}
                                            />
                                    </CardContent>
                                </Card>
                            </Container>
                        </Grid>
                    }
                    isArray={this.props.isArray}
                    handleAdd={this.props.handleAdd}
                    refreshDetails={this.props.refreshDetails}
                    builderList={this.props.builderList ? this.props.builderList : this.state.builderList}
                    idSave={this.props.idSave !== undefined ? this.props.idSave : constants.workSiteFilter  }
                    handleOneSelect={this.props.handleOneSelect}
                    handleSearchOneSelect={this.props.handleSearchOneSelect}
                    handleClose={this.props.handleClose}
                    hideFilters={this.props.hideFilters}
                    cleanReloadRecords={this.handleClose}
                    filterGroups={true}
                    expandedSearch={this.state.expandedSearch}
                                    
                    
                    
                />
            </Fragment>
        )
    };
}

export default withTranslation('common')(WorkSiteList);
